

export default () => {
    $(".menu-cont .title-option").off('click').click(function(e) {
        e.preventDefault();
    });

    $(".menu-cont .title-option").off('click').click(function() {
        $(this)
            .siblings("ul")
            .slideToggle();
        $(this)
            .find(".icon")
            .toggleClass("rotate");
    });

    $(".menu-cont .search").keydown(function() {
        $(".placeholder").hide();
    });

    $(".menu-cont .search").keyup(function() {
        if ($(".search").val() == "") {
            $(".placeholder").show();
        }
    });

    $(".menu-cont .login-menu").find(".search").focus(function(){
        $(this).siblings(".placeholder").find("span").text("¿Qué estás buscando?");
    });

    $(".menu-cont .login-menu").find(".search").focusout(function(){
        $(this).siblings(".placeholder").find("span").text("Buscar");
    });
}
